import React from 'react';

import { ReactComponent as TekyuLogoSvg } from './assets/tekyu-logo.svg';

const TekyuLogo = ({ className, ariaLabel = 'Tekyu' }) => (
  <TekyuLogoSvg
    className={className}
    role="img"
    aria-label={ariaLabel}
    focusable="false"
  />
);

export default TekyuLogo;